<template>
    <v-hover v-slot:default="{ hover }">
    <div class="stickie"
         :style="{'border': hover? '1px solid lightgrey': '1px solid transparent'}"
    >
          <div class="stickie-content" v-bind:style="{ color: note.color, backgroundColor : note.backgroundColor , fontSize: note.fontSize + 'px' }">
              {{label}} {{sensorValue}}
          </div>
          <div>
        <div class="stickie-footer justify-end">

          <v-card-actions>
            <v-spacer></v-spacer>
            <div style="min-width:60px;">
              <v-scroll-y-transition>
              <span v-show="hover & $can('update', 'GraphicalView')">
              <v-tooltip top>
                  <v-btn icon small secondary slot="activator" @click="$refs.stickieEditor.showEditor()">
                    <v-icon>fa-edit</v-icon>
                  </v-btn>
                  <span>Edit this Stickie</span> <!-- background color / delete / content -->
              </v-tooltip>

              <v-tooltip top>
                  <v-btn icon small secondary slot="activator" @click="deleteStickie()">
                    <v-icon>fa-trash</v-icon>
                  </v-btn>
                  <span>Delete this Stickie</span> <!-- background color / delete / content -->
              </v-tooltip>
              </span>
          </v-scroll-y-transition>
              </div>

            <!-- edit dialog -->
            <edit-stickie v-bind="note" :note="note" ref="stickieEditor"></edit-stickie>
          </v-card-actions>
        </div>
      </div>
    </div>
    </v-hover>
</template>

<script>
  import EditStickie from './EditStickie'
  import _ from 'lodash'
  export default {
    name: 'StickieContent',
    components: { EditStickie },
    props: {
      note: Object,
      label: String,
      equipment_name: {type: String, default: null},
      sensor: {type:Object, default:null},
      backgroundColor: {type: String, default:'transparent'}
    },
    computed: {
      bgc () {
        return {
          backgroundColor: this.backgroundColor
        }
      },
      sensorValue () {
        if (!this.sensor) {
          return ''
        }
        let result = _.get(
          _.get(this.$store.getters.normalizedPoints, this.sensor.equipment_name, {}),
          this.sensor.sensor_name,
          null)
        if (!result) {
          return ''
        } else{
          return parseFloat(result['combinedVal']).toFixed(1)+' '+result['unit']
        }

      }
    },
    methods: {
      deleteStickie () {
         this.$store.commit('removeStickie', this.note.id)
      }
    }
  }
</script>

<style scoped>
  .stickie {
    display: flex;
    flex-flow: column;
    width: 100%;
    height: 100%;
  }

  .stickie-content {
    height: 100%;
    overflow: auto;
    text-align: left;
  }
  .stickie-content p {
    padding:0;
    margin:0;

  }

  .stickie-footer {
    min-height:45px;
  }
</style>
